import React, { FC } from 'react';
import { targetLinkdsk } from '../../../utils/targetDskLink';
import CustomExternalAnchor from '../../@shared/customExternalAnchor';
import Icon from '../../@shared/icon';
import { TSecondaryButton } from '../types/productSeriesDetailTestimonial.types';

const SecondaryButton: FC<TSecondaryButton> = (props) => {
  const { showSecondaryButton, buttonSecondary, isDesktop, iconImage } = props;
  if (!showSecondaryButton) return null;
  return (
    <div className="slide-card__button slide-card__button--secondary">
      <span className="link-with-arrow">
        <CustomExternalAnchor field={buttonSecondary} target={targetLinkdsk(buttonSecondary, isDesktop)}>
          {buttonSecondary.value.title}{' '}
        </CustomExternalAnchor>
        <Icon iconName={iconImage} size={24} />
      </span>
    </div>
  );
};

export default SecondaryButton;
